export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Nível da bateria',
    terminal_battery_state: 'Estado de carregamento',
    auto_accept_orders: 'Aceitar encomendas automaticamente',
  },
  auto_accept_orders_modal: {
    title: 'Tem a certeza que pretende aceitar encomendas automaticamente?',
    buttons: {
      activate: 'Ativar',
      cancel: 'Cancelar',
    },
  },
  feedback: {
    update_success: 'Atualizado com sucesso',
    update_failed: 'Falha ao atualizar a informação. Por favor, tente novamente.',
  },
};
